module.exports = __webpack_public_path__ + "img/img_32389_0_448.beb303b3.png";